var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal as BsModal } from 'react-bootstrap';
import { Header, Footer, Body } from './components';
export const Modal = (_a) => {
    var { title, message, show, content, closeLabel, actionLabel, onClose, onAction } = _a, rest = __rest(_a, ["title", "message", "show", "content", "closeLabel", "actionLabel", "onClose", "onAction"]);
    return (_jsx(_Fragment, { children: _jsxs(BsModal, Object.assign({ show: show, onHide: onClose }, rest, { children: [_jsx(Header, { title: title, onClose: onClose }), !!message && _jsx(Body, { message: message }), !!content && _jsx(BsModal.Body, { children: content }), _jsx(Footer, { closeLabel: closeLabel, actionLabel: actionLabel, onClose: onClose, onAction: onAction })] })) }));
};
